// Captura e preserva os parâmetros de campanha (UTM) durante a sessão.
// Spec §18. Guardado em sessionStorage para não vazar entre sessões/abas antigas.

const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
];

const STORAGE_KEY = 'creditall_utm';

// Lê os UTMs da URL atual e persiste (só sobrescreve o que veio preenchido).
export function captureUtmFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) fromUrl[k] = v;
    });
    if (Object.keys(fromUrl).length > 0) {
      const merged = { ...getUtm(), ...fromUrl };
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    }
  } catch (e) {
    // sessionStorage indisponível (aba privada/bloqueada) — ignora, UTM é best-effort.
  }
}

// Retorna os UTMs guardados nesta sessão.
export function getUtm() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}
